import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

/**
 * @deprecated This icon is going to be removed in the future
 * Please use the ArrowForward as an alternative
 */

const ArrowRightIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M7.838 2.131a.5.5 0 1 0-.676.738L12.215 7.5H2.5a.5.5 0 1 0 0 1h9.715l-5.053 4.631a.5.5 0 0 0 .676.738l6-5.5a.502.502 0 0 0 0-.738l-6-5.5Z" />
  </IconWrapper>
)

export default ArrowRightIconSmall
